// extracted by mini-css-extract-plugin
export var banner = "InviteYourFriendsBannerMobile-module__banner___nEEak";
export var heart = "InviteYourFriendsBannerMobile-module__heart___JRx0a";
export var content = "InviteYourFriendsBannerMobile-module__content___wOsfv";